import { cva, VariantProps } from 'class-variance-authority'

export { default as Radio } from './Radio.vue'

export const radioVariants = {
  size: {
    xs: 'size-4',
    sm: 'size-5',
    md: 'size-6',
    lg: 'size-8',
  },
  variant: {
    success: 'accent-success-2',
  },
} as const

export const radioCva = cva('', {
  variants: radioVariants,
  defaultVariants: {
    variant: 'success',
    size: 'md',
  },
})
export type RadioProps = VariantProps<typeof radioCva>
